import React, { useEffect, useState } from "react";

export default function ThemeToggle({ variant = "button" }) {
  const [dark, setDark] = useState(() => {
    try {
      const saved = localStorage.getItem("theme");
      if (saved) return saved === "dark";
      return window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches;
    } catch {
      return false;
    }
  });

  useEffect(() => {
    const el = document.documentElement;
    if (dark) el.classList.add("dark");
    else el.classList.remove("dark");
    try {
      localStorage.setItem("theme", dark ? "dark" : "light");
    } catch {}
  }, [dark]);

  if (variant === "icon") {
    return (
      <button
        onClick={() => setDark(!dark)}
        className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-[#A7C7E7] bg-slate-50/80 dark:bg-slate-900/70 text-[#1E3A8A] dark:text-[#A7C7E7] shadow-sm hover:bg-slate-50 dark:hover:bg-slate-800 focus:outline-none focus:ring-2 focus:ring-[#A7C7E7]"
        aria-label="Toggle dark mode"
        title={dark ? "Switch to light mode" : "Switch to dark mode"}
      >
        <span aria-hidden>{dark ? "☀️" : "🌙"}</span>
      </button>
    );
  }

  return (
    <button
      onClick={() => setDark(!dark)}
      className="no-print text-sm border border-[#A7C7E7] text-[#1E3A8A] dark:text-[#A7C7E7] px-3 py-1.5 rounded-md hover:bg-[#E9F1FF] dark:hover:bg-slate-800 focus:outline-none focus:ring-2 focus:ring-[#A7C7E7]"
      aria-label="Toggle dark mode"
    >
      {dark ? "Light mode" : "Dark mode"}
    </button>
  );
}
